const launch = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7 2v2H2v10h10V9h2v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm9-2v6l-2.293-2.293-6.271 6.271-1.414-1.414 6.271-6.271L10 0z"/></svg>',
};

export { launch as default };
